import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api, errorMessage } from "../api/client";

export type Security = { password_min_length: number; require_mfa: boolean; session_hours: number; allowed_email_domains: string[]; idle_timeout_minutes: number };
export type Organization = { id: string; name: string; slug: string; status: string; timezone: string; locale: string; base_currency: string; logo_url: string; security: Security; created_at: string };

export function useOrganization() {
  return useQuery({
    queryKey: ["organization"],
    queryFn: async () => {
      const { data, error } = await api.GET("/api/v1/accounts/organization/");
      if (error) throw new Error(errorMessage(error));
      return data as unknown as Organization;
    },
  });
}

export function useUpdateOrganization() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (patch: Partial<Organization>) => {
      const { data, error } = await api.PATCH("/api/v1/accounts/organization/", { body: patch as never });
      if (error) throw error;
      return data as unknown as Organization;
    },
    onSuccess: (data) => { qc.setQueryData(["organization"], data); void qc.invalidateQueries({ queryKey: ["me"] }); },
  });
}
